export class StepperTemplate {
    steps: Step[] = [];
    state: State;

    addStep(names: string[], index?: number[]): void {
        if (index == null) {
            for (let i = 0; i < names.length; i++) {
                this.steps[i] = (new Step(names[i]));
            }
        }
        else {
            for (let i = 0; i < index.length; i++) {
                this.steps[i] = new Step(names[index[i]]);
            }
        }
    }

    //remove step at index
    removeStep(index: number) {

    }

    //focus step for index
    setStep(index: number) {
        //this.steps[index] = 
    }

    getStep(name: string) {
        return this.steps.find(s => s.name === name);
    }



    /**
     *  clear the steps with previous settings
     */
    clearSteps() {
        this.steps.forEach(s => {
            s.state = State.None;
            s.description = '';
        })
    }
}

export class Step {
    name: string;
    description: string;
    state: State;

    constructor(name: string, description?: string) {
        this.name = name;
        this.description = description;
    }

    public setState(state: State) {
        this.state = state;
    }
}

export enum State {
    Accepted = 'accepted',
    Cancelled = 'cancelled',
    Rework = 'rework',
    Awaiting = 'awaiting',
    OnHold = 'onHold',
    None = 'none',
}

export enum Index {
    Default = -1,
    New = 0,
    Part,
    Location,
    Work,
    Complete,
}
